import React, {useCallback, useState} from 'react';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {Assignee} from '@buncha/driver/types/vanLoadAt';
import Call from '@buncha/components/core/icon/Call';
import CallDriverBottomSheet from '@buncha/batchDetails/component/VanLoad/CallDriverBottomSheet';
import {CustomText} from '@buncha/components/core/text';
import {HBox} from '@buncha/components/core/view';
import {HomeScreens} from '@buncha/home/navigation/types';
import {Modules} from '@buncha/utils/types';
import {StyleSheet} from 'react-native';
import {Touchable} from '@buncha/components/core/touchable';
import {useGetLocale} from '@buncha/localization/hooks';

interface WaitingForShoppersBannerProps {
  shopperList: Assignee[];
}

const WaitingForShoppersBanner: React.FC<
  WaitingForShoppersBannerProps
> = props => {
  const theme = useColorThemeType('main');
  const muli = useFontTheme('muli');
  const [open, setOpen] = useState(false);
  const shopperList = props?.shopperList ?? [];
  const {body} = useGetLocale(Modules.driver, HomeScreens.Driver) ?? {};
  const toggleBottomSheet = useCallback(() => {
    if (shopperList?.length) setOpen(!open);
  }, [shopperList?.length, open]);
  return (
    <React.Fragment>
      <HBox
        style={[
          styles.textBox,
          {backgroundColor: theme?.background?.yellow?.[200]},
        ]}>
        <CustomText
          style={{
            color: theme?.text?.blue[300],
            fontFamily: muli?.[700]?.normal,
          }}>
          {body?.waitingForShoppers}
        </CustomText>
        <Touchable
          onPress={toggleBottomSheet}
          style={{backgroundColor: theme?.background?.yellow?.[200]}}>
          <Call viewBox="0 -2 25 20" fill={theme?.text?.blue[300]} />
        </Touchable>
      </HBox>
      <CallDriverBottomSheet
        open={open}
        driverList={shopperList}
        onClose={toggleBottomSheet}
      />
    </React.Fragment>
  );
};

export default React.memo(WaitingForShoppersBanner);

export const styles = StyleSheet.create({
  textBox: {
    padding: 12,
    borderRadius: 5,
    marginTop: 10,
  },
});
